import FaqPanel from "./faq.js"

export default FaqPanel
